export const gitCommit = '151c0f6b'
